import payload_plugin_qLmFnukI99 from "/opt/harpia/harpiawms-web/frontend/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/harpia/harpiawms-web/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/harpia/harpiawms-web/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_PSbK9A48ZQ from "/opt/harpia/harpiawms-web/frontend/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import motion_jmBwdqbgTJ from "/opt/harpia/harpiawms-web/frontend/node_modules/@vueuse/motion/dist/nuxt/runtime/templates/motion.js";
import primevue_plugin_egKpok8Auk from "/opt/harpia/harpiawms-web/frontend/.nuxt/primevue-plugin.mjs";
import plugin_client_8fz26Kfk5j from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt-primevue/dist/runtime/plugin.client.mjs";
import _00_opentelemetry_client_A87SEo7EGp from "/opt/harpia/harpiawms-web/frontend/src/plugins/00.opentelemetry.client.ts";
import DModuControle_client_H4OwXKR7rS from "/opt/harpia/harpiawms-web/frontend/src/plugins/DModuControle.client.ts";
import R3logger_client_1aXB2USqVn from "/opt/harpia/harpiawms-web/frontend/src/plugins/R3logger.client.ts";
import axios_client_ccTz6SHL5W from "/opt/harpia/harpiawms-web/frontend/src/plugins/axios.client.ts";
import errorLogging_client_xA6QyrkmxX from "/opt/harpia/harpiawms-web/frontend/src/plugins/errorLogging.client.ts";
import eventBus_client_TO1MaELLJe from "/opt/harpia/harpiawms-web/frontend/src/plugins/eventBus.client.ts";
import fieldDbInfo_client_KodmJWWBEN from "/opt/harpia/harpiawms-web/frontend/src/plugins/fieldDbInfo.client.ts";
import keyboardMode_client_YiSb1AyxuT from "/opt/harpia/harpiawms-web/frontend/src/plugins/keyboardMode.client.ts";
import lodash_client_XxKKOIu1nW from "/opt/harpia/harpiawms-web/frontend/src/plugins/lodash.client.ts";
import logger_client_c79AJI4bSJ from "/opt/harpia/harpiawms-web/frontend/src/plugins/logger.client.ts";
import networkBus_client_AOwZ9JPiMA from "/opt/harpia/harpiawms-web/frontend/src/plugins/networkBus.client.ts";
import notifications_client_Uo4LRFdnSb from "/opt/harpia/harpiawms-web/frontend/src/plugins/notifications.client.ts";
import pwa_client_03FA6liQIe from "/opt/harpia/harpiawms-web/frontend/src/plugins/pwa.client.ts";
import r3fetchdata_client_fnFdAIMcbs from "/opt/harpia/harpiawms-web/frontend/src/plugins/r3fetchdata.client.ts";
import registerExceptions_client_9vxxn8amyI from "/opt/harpia/harpiawms-web/frontend/src/plugins/registerExceptions.client.ts";
import rolarParaOTopo_client_ecd2ygkIRE from "/opt/harpia/harpiawms-web/frontend/src/plugins/rolarParaOTopo.client.ts";
import shortcuts_client_92PcV69OMF from "/opt/harpia/harpiawms-web/frontend/src/plugins/shortcuts.client.ts";
import systemConfigurationEvents_client_HnUNNqNGo2 from "/opt/harpia/harpiawms-web/frontend/src/plugins/systemConfigurationEvents.client.ts";
import websocketMessaging_client_JfiOhdnv83 from "/opt/harpia/harpiawms-web/frontend/src/plugins/websocketMessaging.client.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_PSbK9A48ZQ,
  motion_jmBwdqbgTJ,
  primevue_plugin_egKpok8Auk,
  plugin_client_8fz26Kfk5j,
  _00_opentelemetry_client_A87SEo7EGp,
  DModuControle_client_H4OwXKR7rS,
  R3logger_client_1aXB2USqVn,
  axios_client_ccTz6SHL5W,
  errorLogging_client_xA6QyrkmxX,
  eventBus_client_TO1MaELLJe,
  fieldDbInfo_client_KodmJWWBEN,
  keyboardMode_client_YiSb1AyxuT,
  lodash_client_XxKKOIu1nW,
  logger_client_c79AJI4bSJ,
  networkBus_client_AOwZ9JPiMA,
  notifications_client_Uo4LRFdnSb,
  pwa_client_03FA6liQIe,
  r3fetchdata_client_fnFdAIMcbs,
  registerExceptions_client_9vxxn8amyI,
  rolarParaOTopo_client_ecd2ygkIRE,
  shortcuts_client_92PcV69OMF,
  systemConfigurationEvents_client_HnUNNqNGo2,
  websocketMessaging_client_JfiOhdnv83
]